var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-provider"}},[_c('h2',[_vm._v("\n    Edit\n    "),_c('router-link',{attrs:{"to":{
        name: 'provider',
        params: {
          providerId: _vm.providerId
        }
      }}},[_vm._v("\n      Provider #"+_vm._s(_vm.providerId)+"\n    ")])],1),_vm._v(" "),_c('provider-nav',{attrs:{"providerId":_vm.providerId}}),_vm._v(" "),_c('provider-form',{attrs:{"providerId":_vm.providerId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46767df7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProviderEdit.vue
// module id = 1180
// module chunks = 1